// DADOS FINANCEIROS INFORMADOS DO LEGADO — a regra, sem o IO (feature 012).
//
// O contrato legado nasce do tombamento com o que a folha informa e com
// `valorFinanciado: 0` / `taxaAm: 0`: a Atlas nao tem a cedula. Quem a tem e' o
// credor, e e' ele que informa o principal e a taxa. O que este arquivo fixa:
//
//   1. O que se INFORMA: valor solicitado (> 0) e taxa a.m. (> 0), mais a data
//      do contrato, opcional.
//   2. O que se DERIVA, nunca se digita: CET, IOF e liquido, pelo MESMO
//      `calcCET` do simulador e do formulario de averbacao. Uma segunda conta
//      aqui daria um CET no legado diferente do CET no contrato da Atlas para os
//      mesmos numeros.
//   3. O que fica INTOCADO: parcela, parcela atual e total de parcelas. Vem da
//      folha e continuam sendo a autoridade do legado (ADR-0010 §8). Informar o
//      principal NAO recalcula a parcela; se o `calcCET` com esses dados nao
//      bater com a parcela da folha, isso e' informacao para a tela, nao erro.
//   4. A ORIGEM nao muda. O contrato segue `legado` para margem, amortizacao e
//      conciliacao — so' deixa de ter taxa desconhecida.
import { calcCET } from "./cet.js";
const round2 = (n) => Math.round(n * 100) / 100;
const round4 = (n) => Math.round(n * 10000) / 10000;
/**
 * Deriva CET, IOF, liquido e a parcela teorica a partir do que foi informado e
 * do total de parcelas DA FOLHA.
 *
 * Nao ha caso de erro para principal positivo: o IOF e' proporcional (0,38% +
 * diario com teto de 365 dias por parcela) e nunca alcanca o principal. O
 * portao contra valor zero ou negativo e' o schema da rota.
 */
export function derivarInformeFinanceiro(entrada, totalParcelas) {
    if (!(totalParcelas > 0))
        throw new Error('Informe o cronograma antes de calcular os dados financeiros do contrato.');
    const parcelas = Math.trunc(totalParcelas);
    const cet = calcCET({ valor: entrada.valorSolicitado, parcelas, taxaMensal: entrada.taxaAm });
    return {
        cetAm: round4(cet.mensal),
        iof: round2(cet.iof),
        valorLiquido: round2(cet.valorLiquido),
        parcelaCalculada: round2(cet.parcela),
    };
}
/**
 * Sobrepoe o informe no contrato — em memoria, sem tocar no cronograma.
 *
 * E' a MESMA funcao para os dois caminhos: a leitura do Postgres (que junta a
 * ultima linha da tabela ao documento) e a escrita (que acabou de gravar a
 * linha). Duas copias desta lista de campos seriam duas chances de a tela
 * mostrar um contrato recem-informado diferente do mesmo contrato relido.
 */
export function aplicarDadosInformados(ct, informe) {
    ct.valorFinanciado = round2(informe.valorSolicitado);
    ct.taxaAm = informe.taxaAm;
    ct.cetAm = informe.cetAm;
    ct.iof = informe.iof;
    ct.valorLiquido = informe.valorLiquido;
    if (informe.dataContrato)
        ct.dataContrato = informe.dataContrato;
    ct.dadosInformados = {
        por: informe.por,
        porNome: informe.porNome,
        papel: informe.papel,
        em: informe.em,
        valorSolicitado: round2(informe.valorSolicitado),
        taxaAm: informe.taxaAm,
        dataContrato: informe.dataContrato ?? null,
        motivo: informe.motivo ?? null,
    };
    return ct;
}
/**
 * A parcela informada "bate" com a da folha?
 *
 * Tolerancia de R$ 0,05 por arredondamento de centavos. Divergencia maior e'
 * legitima e frequente — a folha desconta o que o ERP calculou, com tarifas e
 * seguros que a cedula tem e a Atlas nao ve — e por isso e' INFORMACAO, nunca
 * recusa.
 */
export function parcelaInformadaBate(parcelaCalculada, valorParcelaFolha) {
    return Math.abs(parcelaCalculada - valorParcelaFolha) <= 0.05;
}
//# sourceMappingURL=dados-informados.js.map